import { render, staticRenderFns } from "./EditShareholder.vue?vue&type=template&id=bf36b5ac&scoped=true"
import script from "./EditShareholder.vue?vue&type=script&lang=js"
export * from "./EditShareholder.vue?vue&type=script&lang=js"
import style0 from "./EditShareholder.vue?vue&type=style&index=0&id=bf36b5ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf36b5ac",
  null
  
)

export default component.exports